module.exports = __webpack_public_path__ + "img/p_2.1d9b2c20.jpg";